import { Button, IconButton, Stack, Box } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React, { useEffect, useState } from 'react';
import { useFieldArray } from 'react-hook-form';

type Props = {
    control: any;
    name: string;
    defaultObject: any;
    render: (props: { 
        index: number; 
        deleteButton: any;
        moveUpButton: any;
        moveDownButton: any;
        isFirst: boolean;
        isLast: boolean;
    }) => React.ReactNode;
    addMoreText: string;
};

const AddMoreWithReorder = (props: Props) => {
    const [init, setInit] = useState(false);
    const { fields, append, remove, move } = useFieldArray({
        control: props.control,
        name: props.name,
    });

    const deleteButton = (index: number) => {
        return (
            <IconButton
                size="small"
                color="error"
                onClick={e => {
                    e.stopPropagation();
                    remove(index);
                }}
                aria-label="Supprimer">
                <i className="fi fi-br-trash" style={{ fontSize: 16 }} />
            </IconButton>
        );
    };

    const moveUpButton = (index: number, isFirst: boolean) => {
        return (
            <IconButton
                size="small"
                onClick={e => {
                    e.stopPropagation();
                    move(index, index - 1);
                }}
                disabled={isFirst}
                sx={{ padding: 0 }}
                aria-label="Déplacer vers le haut">
                <KeyboardArrowUpIcon fontSize="small" />
            </IconButton>
        );
    };

    const moveDownButton = (index: number, isLast: boolean) => {
        return (
            <IconButton
                size="small"
                onClick={e => {
                    e.stopPropagation();
                    move(index, index + 1);
                }}
                disabled={isLast}
                sx={{ padding: 0 }}
                aria-label="Déplacer vers le bas">
                <KeyboardArrowDownIcon fontSize="small" />
            </IconButton>
        );
    };

    useEffect(() => {
        if (fields.length === 0 && !init) {
            append(props.defaultObject, { shouldFocus: false });
            setInit(true);
        }
    }, [append, fields, init, props.defaultObject]);

    return (
        <Stack spacing={2}>
            {fields.map((field, index) => {
                const isFirst = index === 0;
                const isLast = index === fields.length - 1;
                
                return (
                    <Box key={field.id}>
                        {props.render({
                            index,
                            deleteButton: deleteButton(index),
                            moveUpButton: moveUpButton(index, isFirst),
                            moveDownButton: moveDownButton(index, isLast),
                            isFirst,
                            isLast,
                        })}
                    </Box>
                );
            })}
            <Button
                variant="outlined"
                color="secondary"
                size="small"
                fullWidth
                onClick={() => append(props.defaultObject)}
                startIcon={<i className="fi fi-br-plus" style={{ fontSize: 14 }} />}>
                {props.addMoreText}
            </Button>
        </Stack>
    );
};

export default AddMoreWithReorder;
